module.exports = __webpack_public_path__ + "static/media/banner-success.ad8b3192.svg";